import gql from 'graphql-tag'

export const SUBSCRIBE_GET_AREAGROUPS = gql`
subscription areaGroups($cityId:uuid!){
  areaGroups (where: {cityId: {_eq: $cityId}}){
    id
    name
    cityId
    City{id city}
    }
 }
 `